import React, { Component } from 'react';
import PropTypes from 'prop-types';
import YouTube from 'react-youtube';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Card from '@material-ui/core/Card';
import CardMedia from '@material-ui/core/CardMedia';
import CardContent from '@material-ui/core/CardContent';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardActions from '@material-ui/core/CardActions';
//import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import Button from '@material-ui/core/Button';
import {
  Fullscreen,
  Share,
  SaveAlt
} from '@material-ui/icons';

const styles = theme => ({
  root: {
    margin: '30px 0px'
  },
  mt: {
    marginTop: 20
  },
  image: {
    width: '100%'
  },
  media: {
    height: 0,
    paddingTop: '56.25%', // 16:9
  },
  expand: {
    marginLeft: 'auto'
  },
  flex: {
    flexGrow: 1,
    flex: 1,
    flexDirection: 'row'
  },
  price: {
    widht: 100,
    textAlign: 'center',
    backgroundColor: '#edf0f4',
    borderRadius: 4,
    padding: 10
  }
});


class Item extends Component {

  onReady = evt => {
    //evt.target.pauseVideo();
  }

  expand = () => {
    const { section, onExpand, expendable } = this.props;
    if (!expendable) return;
    onExpand(section.id || section._id)
  }

  hasDescription = section => !!section.description && section.description.length > 0;

  titleVariant = section => !!section.caption ? 'caption' : 'h6';

  toCurrency = num => {
    const formatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionalDigits: 2
    })

    return formatter.format(num);
  }

  /**
   * Wraps card into clicable area
   *
   * @param {string} url Target url
   * @param {node} card Rendered Card
   * @returns {node} Wrapped card
   */
  renderClickableCard = (url, card) => <CardActionArea href={url} target="blank">
      {card}
    </CardActionArea>

  /**
   * Renders card
   *
   * @param {object} section Target url
   * @param {string} type Rendered Card
   * @param {object} classes Styles
   * @returns {node} Card
   */
    renderCard = () => {

      const { section, type, classes, sharable, downloadable, expendable, purchasable, height, opts } = this.props;
      return (
        <Card>
            {type === 'photo' &&
              <CardActionArea onClick={this.expand}>
                <CardMedia image={section.image || section.imageUrl} title={section.caption || section.description} className={classes.media} />
              </CardActionArea>
            }

            {type === 'video' && <YouTube videoId={section.url} opts={opts} onReady={this.onReady} />}
            <CardContent style={{ minHeight: height }}>

              <Typography variant={this.titleVariant(section)}>
                {section.caption || section.description || section.title || ""}
              </Typography>

              {/*this.hasDescription(section) &&
                <Divider className={classes.mt} />
              }
              {this.hasDescription(section) &&
                <Typography className={classes.mt} variant="body1">
                  {section.description}
                </Typography>
              */}

            </CardContent>
            <CardActions>
              { sharable &&
                <IconButton>
                  <Share />
                </IconButton>
              }

              { expendable &&
                <IconButton className={classes.expand} onClick={this.expand}>
                  <Fullscreen />
                </IconButton>
              }

              { purchasable &&
                <div className={classes.flex}>
                  <Button target="blank" size="large" href={section.url} variant="contained" color="primary" fullWidth>
                    BUY ON AMAZON
                  </Button>
                </div>
              }

              { downloadable &&
                <IconButton className={classes.expand}>
                  <SaveAlt />
                </IconButton>
              }
            </CardActions>
          </Card>
      )
    }

  render() {
    const { section, width, clickable } = this.props;
    let card = this.renderCard();
    if (clickable && section.link && section.link.length > 0) {
      card = this.renderClickableCard(section.link, card);
    }

    return (
      <Grid key={section.id} item xs={12} sm={width}>
        {card}
      </Grid>
    )
  }
}

Item.propTypes = {
  classes: PropTypes.object.isRequired
}

export default withStyles(styles)(Item);

